import { ReactNode } from 'react';

import { IconEducation } from '@astrumu/ui-library';

import { DegreeLevel, AdvertisementSource } from '@/graphql/generated';

import {
  Match,
  ProfileTabs,
  CredentialType,
  ActionItemType,
  ActionItemsModals,
  JobRecommendationOverviewTabs
} from '../types';

export * from './modals';

export const DEGREE_MAPPING: {
  [key in DegreeLevel]: string;
} = Object.freeze({
  [DegreeLevel.Associates]: 'Associates Degree',
  [DegreeLevel.Bachelors]: 'Bachelors Degree',
  [DegreeLevel.Doctoral]: 'Doctoral Degree',
  [DegreeLevel.HighSchool]: 'High School Degree',
  [DegreeLevel.Masters]: 'Masters Degree'
});

export const DEGREE_ORDER = [
  DegreeLevel.HighSchool,
  DegreeLevel.Associates,
  DegreeLevel.Bachelors,
  DegreeLevel.Masters,
  DegreeLevel.Doctoral
];

export const ADVERTISEMENT_SOURCE_MAPPING: {
  [key in AdvertisementSource]: string;
} = Object.freeze({
  [AdvertisementSource.Ausa]: 'AUSA',
  [AdvertisementSource.ClearanceJobs]: 'Clearance Jobs',
  [AdvertisementSource.HiringOurHeroes]: 'Hiring Our Heroes',
  [AdvertisementSource.OperationMilitaryFamily]: 'Operation Military Family',
  [AdvertisementSource.PmProlearn]: 'PM-ProLearn',
  [AdvertisementSource.RecruitMilitary]: 'Recruit Military',
  [AdvertisementSource.Tap]: 'TAP',
  [AdvertisementSource.Umb]: 'UMB',
  [AdvertisementSource.Aff]: 'Your Next Mission (AFF)',
  [AdvertisementSource.Astrumu]: 'AstrumU',
  [AdvertisementSource.Other]: 'Other'
});

export const JOB_RECOMMENDATION_OVERVIEW_TABS = [
  {
    id: JobRecommendationOverviewTabs.Overview,
    name: 'overview'
  },
  { id: JobRecommendationOverviewTabs.SkillsGap, name: 'skills and abilities' }
];

export const PROFILE_TABS = [
  { id: ProfileTabs.History, name: 'history' },
  { id: ProfileTabs.Skills, name: 'skills' },
  { id: ProfileTabs.Documents, name: 'documents' },
  { id: ProfileTabs.Saved, name: 'saved' }
];

export const MATCH_MAPPING: {
  [key in Match]: { minScore: number; label: string; color: string };
} = Object.freeze({
  [Match.NotEnoughData]: {
    label: 'not enough data',
    minScore: 0,
    color: '#D9E3EB'
  },
  [Match.Fair]: { label: 'fair', minScore: 10, color: '#E45050' },
  [Match.Moderate]: { label: 'moderate', minScore: 20, color: '#FA9256' },
  [Match.Good]: { label: 'good', minScore: 40, color: '#E3CB4D' },
  [Match.VeryGood]: { label: 'very good', minScore: 60, color: '#68C699' },
  [Match.Excellent]: { label: 'excellent', minScore: 80, color: '#30A8F2' }
});
export const ACTION_ITEM_MODAL_MAPPING: ActionItemsModals = {
  jst: {
    update: 'uploadJST',
    delete: 'deleteJST'
  },
  srb: {
    update: 'uploadSRB',
    delete: 'deleteSRB'
  },
  resume: {
    update: 'uploadResume',
    delete: 'deleteResume'
  },
  'personal-information': {
    update: 'updatePersonalInformation'
  },
  linkedin: {
    update: 'updateLinkedinProfile'
  },
  'transition-preferences': {
    update: 'updateTransitionPreferences'
  }
};

export const COMPLETED_ACTION_ITEM_PROPS_BY_TYPE: {
  [key in ActionItemType]: {
    description: string;
    profileTab: ProfileTabs;
  };
} = {
  file: {
    description:
      "This document has been stored in your user profile's documents section.",
    profileTab: ProfileTabs.Documents
  },
  account: {
    description:
      "This information has been stored in your user profile's history section.",
    profileTab: ProfileTabs.History
  },
  linkedin: {
    description:
      "Your LinkedIn profile has been stored in your user profile's history section.",
    profileTab: ProfileTabs.History
  }
};

export const HIRING_OUR_HEROES_URL = 'https://hiringourheroes.yourjobboard.io/';
export const INDEED_URL = 'https://www.indeed.com/';

export const INFINITE_SCROLL_ITEMS_PER_PAGE = 20;

export const PAGINATED_ITEMS_PER_PAGE = 10;

export const MINIMUM_CHARS_FOR_SEARCH = 3;

export const PRICE_FILTER_MAPPING: { [key in string]: string } = {
  '*-0.1': 'Free',
  '0.1-1000.0': 'Up to $1,000',
  '1000.0-5000.0': '$1,000 - $5,000',
  '5000.0-10000.0': '$5,000 - $10,000',
  '10000.0-*': 'Over $10,000'
};

export const DURATION_FILTER_MAPPING: { [key in string]: string } = {
  '*-3.0': 'Less than 3 months',
  '3.0-6.0': '3 - 6 months',
  '6.0-12.0': '6 months - 1 Year',
  '12.0-24.0': '1 - 2 Years',
  '24.0-*': 'Above 2 Years'
};

export const CREDENTIAL_ICON_BY_TYPE: { [key in CredentialType]: ReactNode } = {
  Degree: <IconEducation.Degree />,
  Certificate: <IconEducation.Certificate />,
  Certification: <IconEducation.Certificate />,
  Apprenticeship: <IconEducation.Apprenticeship />,
  License: <IconEducation.License />,
  'Workforce Development': <IconEducation.Workforce />
};

export const DEFAULT_UNIVERSITY_LOGO = '/assets/img/university.jpg';
